<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer" class="white--text"></v-toolbar-side-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">Change Password</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content>
      <v-layout row wrap>
        <v-flex
          xs12
          text-xs-center
          layout
          align-content-start
          justify-center
          pa-3
        >
          <v-form ref="form" v-model="frmValid">
            <v-text-field
              v-model="txtPassword"
              :rules="[v => !!v || 'Password is required']"
              label="Current Password"
              :type="'password'"
              required
            ></v-text-field>
            <v-text-field
              label="New Password"
              v-model="txtNewPassword"
              :rules="[v => !!v || 'Password is required', v => (v && v.length >= 8) || 'Password must be 8 characters or more']"
              :type="'password'"
              required
            ></v-text-field>
            <v-text-field
              label="Confirm New Password"
              v-model="txtNewPassword2"
              :rules="[v => !!v || 'Password is required', v => (v && v.length >= 8) || 'Password must be 8 characters or more']"
              :type="'password'"
              required
            ></v-text-field>
            <v-btn
              block
              large
              color="primary"
              :disabled="!frmValid"
              @click="submit"
            >
              Change Password
            </v-btn>
          </v-form>
        </v-flex>
      </v-layout>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<style scoped>
form {
  width: 100%;
}
</style>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import Loading from '@/components/Loading.vue'
import router from '../router'
import axios from 'axios'

export default {
  components: {
    SideDrawer,
    Loading
  },
  data: () => ({
    drawer: false,
    loading: false,
    frmValid: true,
    txtPassword: '',
    txtNewPassword: '',
    txtNewPassword2: ''
  }),

  mounted () {
    this.openDrawerForDesktop()
    this.disableBottomDetector()
  },

  methods: {
    submit () {
      if (this.$refs.form.validate()) {
        if (this.txtNewPassword === this.txtNewPassword2) {
          this.loading = true
          axios.put(process.env.VUE_APP_API_ROOT + '/v1/me/password', {
            currentPassword: this.txtPassword,
            newPassword: this.txtNewPassword
          }, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(resp => {
              this.loading = false
              console.log(resp.data)
              if (resp.data.status === 'success') {
                window.alert('Password updated')
              } else {
                window.alert(resp.data.message)
              }
            })
            .catch(function (error) {
              if (error.response) {
                console.log(error.response.status)
                if (error.response.status === 401) {
                  router.push('/login?next=/me/password')
                } else if (error.response.status === 403) {
                  this.showAlert(error)
                }
                this.loading = false
              }
            })
        } else {
          window.alert('New password mismatch')
        }
      }
    },
    goBack () {
      router.go(-1)
    }
  }
}
</script>
